// @ts-nocheck

import { App as CapacitorApp } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import { IonicVue } from "@ionic/vue";
import { DisableSwipeBackDirective } from "v-disable-swipe-back";
import { createApp } from "vue";
import { createGtm } from "vue-gtm";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { setAppOrigin, setAxiosBaseUrl } from "./utils/basics";
import BackButton from "./components/BackButton.vue";

// const { GanglTools } = Plugins;

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/display.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";

/* Theme variables */
import "./theme/variables.css";

/* Gangl Theme */
import { apiLogout } from "./api/auth";
import "./theme/main.scss";

if (Capacitor.isPluginAvailable("StatusBar")) {
  StatusBar.setStyle({ style: Style.Light });
  // StatusBar.setOverlaysWebView({ overlay: true });
  if (Capacitor.getPlatform() === "android") {
    StatusBar.setBackgroundColor({ color: "#f2f4f8" });
  } else if (Capacitor.getPlatform() === "ios") {
    Keyboard.setAccessoryBarVisible({ isVisible: true });
  }

  // InsetsPlugin.top().then((resp: { value: number }) => {
  //   document.documentElement.style.setProperty(
  //     "--ion-safe-area-top",
  //     `${resp.value}px`
  //   );
  // });
}

const app = createApp(App)
  .use(IonicVue)
  .use(store)
  .use(
    createGtm({
      id: "GTM-WKT4N24", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      // queryParams: {
      //   // Add url query string when load gtm.js with GTM ID (optional)
      //   gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
      //   gtm_preview: "env-4",
      //   gtm_cookies_win: "x",
      // },
      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      // nonce: "2726c7f26c", // Will add `nonce` to the script tag
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: process.env.NODE_ENV === "production" ? false : true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      // ignoredViews: ["homepage"], // Don't trigger events for specified router names (case insensitive) (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    })
  )
  .use(VueGoogleMaps, {
    load: {
      key: "AIzaSyAV5E84H9_VGZvWahLupKpBqtNix7GUHdM",
      libraries: "places",
    },
  })
  .directive("disable-swipe-back", DisableSwipeBackDirective);

app.config.globalProperties.$log = console.log;
app.config.globalProperties.$browser = Browser;

app.component("BackButton", BackButton);

router.afterEach((to) => {
  const screenName = to?.meta?.gtm ? to.meta.gtm : to.name;
  app.config.globalProperties.$gtm.trackView(screenName, to.path);
});

// window.createModal = async (modalObject) => {
//   console.log(modalObject);
//   return new Promise((resolve) => {
//     const modal = modalController.create(modalObject);
//     resolve(modal);
//   });
// };

app.use(router);

app.mixin({
  mounted() {
    if (!this.$store.state.isScrolledTop) {
      this.$store.commit("setIsScrolledTop", true);
    }
    const content = this.$refs.content;
    if (content) {
      this.$refs.content.$el.getScrollElement().then((scrollElement) => {
        console.log(scrollElement);
        this.addScrollListener(scrollElement);
      });
    }
    const scrollElement = this.$refs.scrollElement;
    if (scrollElement) {
      console.log(scrollElement);
      this.addScrollListener(scrollElement);
    }
  },
  unmounted() {
    if (
      !["home", "qualitysmile"].includes(this.$route.name) &&
      this.$store.state.isScrolledTop
    ) {
      this.$store.commit("setIsScrolledTop", false);
    }
  },
  methods: {
    addScrollListener(scrollElement) {
      scrollElement.addEventListener("scroll", (event) => {
        if (this.$store.state.isScrolledTop && scrollElement.scrollTop > 0) {
          this.$store.commit("setIsScrolledTop", false);
        } else if (
          !this.$store.state.isScrolledTop &&
          scrollElement.scrollTop === 0
        ) {
          this.$store.commit("setIsScrolledTop", true);
        }
      });
    },
  },
});

(async () => {
  if (Capacitor.isNativePlatform()) {
    // const isRunningTestEnvironment =
    //   await GanglTools.isRunningTestEnvironment();
    // console.log("isRunningTestEnvironment", isRunningTestEnvironment);
    // if (isRunningTestEnvironment.value) {
    //   setAxiosBaseUrl("https://stage.roodie-health.com/arag/api/");
    //   setAppOrigin("https://stage.roodie-health.com");
    // }
    const { id } = await CapacitorApp.getInfo();
    console.log("CapacitorApp.getInfo.id", id);
    if (
      [
        "com.roodie-health.arag.app.stage",
        "com.roodie_health.arag.app.stage",
      ].includes(id)
    ) {
      setAxiosBaseUrl("https://stage.roodie-health.com/arag/api/");
      setAppOrigin("https://stage.roodie-health.com");
    }
    if (Capacitor.getPlatform() === "ios") {
      // eslint-disable-next-line
      wkWebView.injectCookie(
        "roodie.at",
        "/",
        (success) => {
          console.log("cookie injected", success);
        },
        (error) => {
          console.log("cookie not injected", error);
        }
      );
    } else if (Capacitor.getPlatform() === "android") {
      await apiLogout();
    }
  }

  router.isReady().then(() => {
    app.mount("#app");
    SplashScreen.hide();
  });
})();
